module.exports = {
  projectName: process.env.VUE_APP_PROJECT || "",
  webfeedDebuggerWebsiteUrl: false,
  webfeedConfig: false,
  snitch: {
    enabled: true, // show snitch card
    devicePrefix: "" // derive from projectName
  }
};
